function validateDOBControllers(controllers) {
  Object.keys(controllers).forEach(controllerName => {
    const controller = controllers[controllerName]

    if (controllerName.includes('dob') && controller.getStatus().value) {
      controller.validate()
    }
  })
}

export { validateDOBControllers }
